import './App.css';
import Navbar from './components/Navbar';
import Carthover from './components/carthover';
import { useState } from 'react';
import Landingpage from './components/Landingpage';
import { cart } from './components/carts';
import Final from './components/final';
import Carts from './components/carts';
import './components/mainbody.css'

function App() {
  
  const [imgnum, setimage] = useState(0);
  const [imgstyle, setimgstyle] = useState(null);
  const [remove,setremove]=useState(false);
  const [click,setclick]=useState(false);
  const [carte, setCart] = useState([]);
  
  

  
  const clickcart=()=>{
      if(click){
        setclick(false)
      }
      else{
        setclick(true)
      }
  }
  
  

  return (
    <div className="App">
     <div className={remove?"mainbody":"mainbodys"}>
     <Navbar clickcart={clickcart}  />
     {console.log(cart)}
      {cart.length > 0 ? <Carts /> : null}
      {click ? (
        <Carthover 
         
          
        />
      ) : null}
      {/* Passing imgnum, setimage, and imgstyle to Landingpage */}
      <Landingpage carte={carte} setCart={setCart} remove={remove} setremove={setremove}
        imgnum={imgnum} 
        setimage={setimage} 
        imgstyle={imgstyle} 
      />
     </div>
      {remove?<Final remove={remove} setremove={setremove} imgnum={imgnum} 
        setimage={setimage} 
        imgstyle={imgstyle} />:null}
        
    </div>
  );
}

export default App;
